import { render, staticRenderFns } from "./ServicosForm.vue?vue&type=template&id=90c6058e"
import script from "./ServicosForm.vue?vue&type=script&lang=js"
export * from "./ServicosForm.vue?vue&type=script&lang=js"
import style0 from "./ServicosForm.vue?vue&type=style&index=0&id=90c6058e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports